<template>
    <v-app style="background-color: white !important;" class="mt-5">
        <v-row no-gutters align="center" justify="start">
            <v-col cols="2">
                <h3>Add File:</h3>
            </v-col>
            <v-col cols="10">

                <v-file-input
                        ref="uploadField"
                        @change="uploadFile($event)"
                        accept=".doc, .docx, .xls, .xlsx, .zip, .pdf, .csv, .ppt, .pttx, image/*"
                        :name="uploadField"
                        :loading="uploading"
                        :rules="maxFileSizeRule"
                        show-size
                        prepend-icon="mdi-plus-circle"
                        color="primary"
                ></v-file-input>

            </v-col>
            <i>Max file size is 7 MB. If uploading a large file, please allow longer time for the upload to process.</i>
        </v-row>
        <v-row no-gutters v-if="this.files.length > 0"  align="center">
            <v-col>
                <v-data-table
                        :headers="headers"
                        :items="this.files"
                        disable-pagination
                        hide-default-footer
                        hide-default-header
                        class="elevation-1 mt-3"
                        no-data-text="No files have been uploaded."
                >
                    <template v-slot:item.remove="{ item }">
                        <v-btn elevation="0" fab text small color="error" @click="removeFile(item)"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-app>
</template>

<script>
    import { Storage } from 'aws-amplify';
    import SetS3Config from '../services/setS3Config'

    SetS3Config();

    export default {
        name: "FileUploads",
        props: {
            files: {
                type: Array,
            },
        },
        data: () => ({
            filesArePresent: false,
            uploading: false,
            uploadField: "file-upload",
            maxFileSize: 7000000,
            maxFileSizeRule: [
                value => !value || value.size < 7000000 || 'File size should be less than 7 MB.',
            ],
            headers: [
                { text: 'File Name', align: 'start', value: 'name', sortable: false },
                { text: 'Remove', value: 'remove', sortable: false, align: 'end' },
            ],
        }),
        methods: {
            uploadFile: function (event) {
                let file = event;

                if (!file) return;

                if (file.size > this.maxFileSize) {
                    console.log("File too large.");
                    return;
                }

                this.uploading = true;
                let newUpload = {};
                newUpload.name = file.name;
                let now = new Date();
                let year = now.getFullYear();
                let month = now.getMonth();
                let day = now.getDay();


                Storage.put(`uploads/${year}/${month}/${day}/${file.name}`,
                    file,
                    { contentType: file.type })
                    .then(result => {
                        newUpload.s3Key = result.key;
                        this.uploading = false;

                        this.$emit('add-file', newUpload);

                        this.filesArePresent = true;
                        this.$refs.uploadField.reset();
                    })
                    .catch(() => {
                        this.uploading = false;
                        console.log("Cannot upload file")
                    });
            },
            removeFile(file) {
                this.$emit('remove-file', file)
            },
        }
    }
</script>

<style scoped>

</style>